import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import ApplyLink from './ApplyLink';
// ── Served from public/, NOT imported (CMSY-114) ───────────────────────────
// An imported asset gets a content-hashed filename that only exists after the
// bundler runs, so nothing can reference it from index.html. A stable path
// under public/ can be PRELOADED in the initial HTML, which is the whole point:
// the browser's preload scanner starts the download while the HTML is still
// parsing, instead of waiting for the JS bundle to execute and apply a style.
//
// The <link rel="preload"> in public/index.html and this constant must name the
// same file. They are asserted to agree by a test — a preload pointing at a
// path the page never requests is a wasted round trip that looks like a
// optimisation.
const HERO_IMAGE = '/hero-foodtruck.webp';

const Hero: React.FC = () => {
  return (
    <section className="hero" style={{ backgroundImage: `url(${HERO_IMAGE})` }}>
      <div className="hero-overlay">
        <div className="hero-content">
          <h1>Vancouver's Leader<br/>in Shared-Use Commercial<br/>& Commissary Kitchen Rentals</h1>
          <p>Purpose-built for food trucks, caterers, meal prep services, bakeries, ghost kitchens, and CPG manufacturers</p>
          <div className="hero-buttons">
            <ApplyLink className="btn-primary" label="Hero Section Apply Now">
              Apply Now
            </ApplyLink>
            <Link to="/our-kitchens" className="btn-secondary">Explore Our Kitchens</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;